export default "__VITE_ASSET__B$x3UP2W__"